/**
 * This enum is used for referring Primary Navigation URL Path.
 */
export enum MainNavigationEnum {
  LOGIN = 'login',
  UNAUTHORIZED = 'unauthorized',
  USERS = 'users',
  TOKENS = 'tokens',
  CLIENTS = 'clients',
}
